import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GenSingleImagePreviewData } from '../../../../../../../models/google-template/preview-interfaces/gen-single-image-preview-data.interface';
import { CreativeFormat, CreativeImageRouterHelper } from '../../../../../../../utils/creative-image-router-helper';
import { DesktopFrameComponent } from '../../../preview-common/desktop-frame/desktop-frame.component';

@Component({
    selector: 'app-gen-display-ad-desktop-05',
    imports: [CommonModule, DesktopFrameComponent],
    templateUrl: './display-ad-desktop-05.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: [
        '../../../preview-common/display/display-desktop-styles.scss',
        './display-ad-desktop-05.component.scss',
    ]
})
export class DisplayAdDesktop05PreviewComponent {
  @Input() data!: GenSingleImagePreviewData;

  /** This placement's creative slot is the 1.91:1 landscape format. */
  readonly creativeFormat: CreativeFormat = 'landscape';

  /** Shown in place of the creative when the matching upload is missing. */
  readonly missingDimensionLabel = CreativeImageRouterHelper.labelFor(this.creativeFormat);

  /** The uploaded creative matching {@link creativeFormat}, if any. */
  get creativeImage(): string {
    return CreativeImageRouterHelper.resolve(this.data.images ?? [], this.creativeFormat);
  }

  /**
   * Row count for the skeleton article text above the lead image. The mock draws
   * four full lines and a short one, and only the count matters, so the array is
   * empty on purpose.
   */
  readonly bodyBars = Array.from({ length: 5 });

  /** The publisher site nav, drawn as inert pills. Count only, as above. */
  readonly navItems = Array.from({ length: 4 });
}
